import strings from 'strings';

const COPIES = strings.ai.generators.roleplay.callVerbiages;

export const CALL_VERBIAGES_TYPES = {
  marketing: {
    description: COPIES.description,
    id: 'marketing',
    title: COPIES.marketing,
    type: 'Marketing'
  },
  recruiting: {
    description: COPIES.description,
    id: 'recruiting',
    title: COPIES.recruiting,
    type: 'Recruiting'
  }
};
